// extracted by mini-css-extract-plugin
export default {"popoverViewer":"TooltipsViewer_popoverViewer__XYEd+"};